import { DestinationEvent } from '@eventbrite/event-renderer';
import React from 'react';
import { BentoCarousel } from '../../components/BentoCarousel';
import styles from './BentoCarouselSection.module.scss';
import { useGetCategoryData } from './utils';

export interface BentoCarouselSectionProps {
    nearbyEvents: Array<DestinationEvent>;
    nearbyFreeEvents: Array<DestinationEvent>;
    nearbyNightlifeEvents: Array<DestinationEvent>;
    orderedCategories: string[];
}

const BentoCarouselSection: React.FC<BentoCarouselSectionProps> = ({
    nearbyEvents,
    nearbyFreeEvents,
    nearbyNightlifeEvents,
    orderedCategories,
}) => {
    const categoryEventData = useGetCategoryData({
        nearbyEvents,
        nearbyNightlifeEvents,
        nearbyFreeEvents,
        orderedCategories,
    });

    return (
        <section>
            {categoryEventData.map(({ key, title, events }) => (
                <div
                    key={key}
                    className={styles.singleBentoContainer}
                    data-testid="bento-carousel"
                >
                    <BentoCarousel
                        title={title}
                        events={events}
                        lazyLoadCarouselElements={true}
                    />
                </div>
            ))}
        </section>
    );
};

export default BentoCarouselSection;
